import {
    ApiHandler,
    createHandlerChainRunnerOptionalParameter,
    HasOnError,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import { ServiceResult } from "@insite/client-framework/Services/ApiService";
import { getNewProducts } from "@midland-industries/Services/NewProductService";
import { xcentiumNewProductActions } from "@midland-industries/Store/Data/NewProducts/NewProductsReducer";
import { GetNewProductsParameter, GetNewProductsResponseModel } from "@midland-industries/Types/NewProductModels";
import { DispatchProp } from "react-redux";

type Props = DispatchProp<xcentiumNewProductActions>;

type GetNewProductsApiParameter = GetNewProductsParameter &
    HasOnSuccess<GetNewProductsResponseModel> &
    HasOnError<string>;

type HandlerType = ApiHandler<GetNewProductsApiParameter, ServiceResult<GetNewProductsResponseModel>, Props>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const RequestDataFromApi: HandlerType = async props => {
    const apiResult = await getNewProducts(props.apiParameter);
    props.apiResult = apiResult;
};

export const BeginLoadNewProducts: HandlerType = props => {
    props.dispatch({
        type: "Custom/NewProducts/BeginLoad",
        params: props.apiParameter,
    });
};

export const ExecuteOnErrorCallback: HandlerType = props => {
    if (!props.apiResult.successful) {
        props.parameter.onError?.(props.apiResult.errorMessage);
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (props.apiResult.successful) {
        props.parameter.onSuccess?.(props.apiResult.result);
    }
};

export const DispatchCompleteLoad: HandlerType = props => {
    if (props.apiResult.successful) {
        props.dispatch({
            type: "Custom/NewProducts/CompleteLoad",
            params: props.apiParameter,
            result: props.apiResult.result,
        });
    }
    if (!props.apiResult.successful) {
        props.dispatch({
            type: "Custom/NewProducts/CompleteLoad",
            params: props.apiParameter,
            result: {
                products: [],
                categories: [],
            } as GetNewProductsResponseModel,
        });
    }
};

export const chain = [
    PopulateApiParameter,
    BeginLoadNewProducts,
    RequestDataFromApi,
    ExecuteOnErrorCallback,
    ExecuteOnSuccessCallback,
    DispatchCompleteLoad,
];

const loadNewProducts = createHandlerChainRunnerOptionalParameter(chain, {}, "LoadNewProducts");
export default loadNewProducts;
